export default __webpack_public_path__ + "static/media/remove.e9329663.svg";